import { type PlaceSuggestion } from "@/hooks";

export const fetchPlaceSuggestions = async (
  input: string
): Promise<PlaceSuggestion[]> => {

  const res =
    await window.google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
      input,
      includedRegionCodes: ["us"],
      locationBias: {
        lat: 33.9416, // LAX
        lng: -118.4085,
      },
    });

  return res.suggestions.map((s) => ({
    placeId: s.placePrediction?.placeId ?? "",
    description: s.placePrediction?.text?.text ?? "",
  }));
};